import { SimpleTextCell } from 'components/Table/Cells/SimpleTextCell';
import { Column } from 'react-table';
import { formatMoney } from 'utils';

export function createTableColumns({ partnerView }: { partnerView: boolean }): Column<any>[] {
  return (
    [
      {
        Header: 'Product Name',
        filterable: true,
        show: partnerView,
        accessor: 'productName',
        Cell: ({ original }: any) => <SimpleTextCell value={original.productName} />,
      },
      {
        Header: 'Dealer Name',
        filterable: true,
        show: !partnerView,
        accessor: 'accountName',
        Cell: ({ original }: any) => <SimpleTextCell value={original.accountName} />,
      },
      {
        Header: 'Product Category Name',
        filterable: true,
        show: false,
        accessor: 'productCategory',
        Cell: ({ original }: any) => <SimpleTextCell value={original.productCategory} />,
      },
      {
        Header: '# Sent',
        accessor: 'totalSent',
        show: true,
        Cell: ({ original }: any) => <SimpleTextCell value={original.totalSent} />,
      },
      {
        Header: '# Accepted',
        accessor: 'totalAccepted',
        show: true,
        Cell: ({ original }: any) => <SimpleTextCell value={original.totalAccepted} />,
      },
      {
        Header: '# Sold',
        accessor: 'totalSold',
        show: true,
        Cell: ({ original }: any) => <SimpleTextCell value={original.totalSold} />,
      },
      {
        Header: 'Sent to Accepted %',
        accessor: 'sentToAccepted',
        show: true,
        Cell: ({ original }: any) => <SimpleTextCell value={original.sentToAccepted} />,
      },
      {
        Header: 'Cost $ (of Accepted)',
        accessor: 'acceptedCost',
        show: true,
        Cell: ({ original }: any) => <SimpleTextCell value={formatMoney(original.acceptedCost, 0) || ''} />,
      },
      {
        Header: 'Retail Price $ (of Accepted)',
        accessor: 'acceptedRetailPrice',
        show: true,
        Cell: ({ original }: any) => <SimpleTextCell value={formatMoney(original.acceptedRetailPrice, 0) || ''} />,
      },
      {
        Header: 'Avg Markup $ (of Accepted)',
        accessor: 'avgMarkupFixedAccepted',
        show: true,
        Cell: ({ original }: any) => <SimpleTextCell value={formatMoney(original.avgMarkupFixedAccepted, 0) || ''} />,
      },
      {
        Header: 'Avg Markup % (of Accepted)',
        accessor: 'avgMarkupPercAccepted',
        show: true,
        Cell: ({ original }: any) => <SimpleTextCell value={formatMoney(original.avgMarkupPercAccepted, 0) || ''} />,
      },
      {
        Header: 'Sold $',
        accessor: 'soldRetailPrice',
        show: true,
        Cell: ({ original }: any) => <SimpleTextCell value={formatMoney(original.soldRetailPrice, 0) || ''} />,
      },
      {
        Header: 'Total Markup of Sold $',
        accessor: 'totalMarkupSold',
        show: true,
        Cell: ({ original }: any) => <SimpleTextCell value={original.totalMarkupSold} />,
      },
    ] as Column[]
  ).map(header => ({
    ...header,
    resizable: true,
    headerClassName: 'customHeader',
  }));
}
